import { createFileRoute } from "@tanstack/react-router";
import { savedDogsRoute, SavedDogsPage } from "@/app-clients/saved-dogs";

export const Route = createFileRoute("/saved")({
    ssr: savedDogsRoute.ssr,
    loader: savedDogsRoute.loader,
    head: savedDogsRoute.head,
    component: SavedDogsPage,
});
